<mat-form-field class="search-bar" appearance="outline" >
	<mat-icon class="search" svgIcon="search"></mat-icon>
	<input matInput [(ngModel)]="searchTerm" placeholder="{{placeholder | translateWithKeys}}" (input)="onSearch()">
	@if(searchTerm){
		<mat-icon matSuffix  (click)="clearSearch()">close</mat-icon>
	}
</mat-form-field>
